import { doGet } from './common';
const LOOUT_URL = 'http://auth.tmrmetal.com/auth/logout?redirect_uri=/';
const logout = () => {
  return doGet(LOOUT_URL)
    .then(() => {
      window.localStorage.clear();
      window.location.href = '/';
    })
    .catch(err => {
      console.error(err)
    }).finally(() => {
      window.localStorage.clear();
      window.location.href = '/';
    });
}

const getToken = (code) => {
  return doGet(`/api/token?code=${code}`)
    .then((data) => {
      window.localStorage.setItem('token', data.data.access_token);
      return data.data
    })
    .catch(err => {
      //alert(JSON.stringify(err))
    }).finally(() => {

    });
}
const checkToken = (token) => {
  return doGet(`/api/token/check?token=${token}`)
    .then(data => (data.data))
    .catch(err => {
      //alert(JSON.stringify(err))
    }).finally(() => {

    });
}

const getDatetime = () => {
  return doGet(`/api/datetime`)
    .then(data => (data.data))
    .catch(err => {
      //alert(JSON.stringify(err))
    }).finally(() => {

    });
}

export {
  getDatetime,
  getToken,
  checkToken,
  logout
}